import React from 'react';
import { Button } from '@mui/material';
import TEXT from './text';
import { useSelector } from 'react-redux';

const ImagePickerComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const { options = {}, constrains = {} } = properties;
    const language = useSelector(state => state.App_Settings.language);

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (!file) {
            return;
        }

        if (constrains.maxSize && file.size > constrains.maxSize) {
            return;
        }

        if (constrains.accept && !constrains.accept.includes(file.type)) {
            return;
        }

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(file);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? file !== null : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(file);
        }
    };

    return (
        <Button
            variant={options.variant || 'contained'}
            component="label"
        >
            {options.label || TEXT.ImagePicker[language]}
            <input
                type="file"
                hidden
                accept={constrains.accept || '*/*'}
                onChange={handleFileChange}
            />
        </Button>
    );
};

export default ImagePickerComponent;
